const getFullName = (firstName, lastName) => {
    const first = (firstName === null || firstName === void 0 ? void 0 : firstName.trim()) || '';
    const last = (lastName === null || lastName === void 0 ? void 0 : lastName.trim()) || '';
    return `${first} ${last}`.trim();
};
export default getFullName;
